import React, { useState } from "react";
import { useWindowSize } from "components/camera/Camera";
const isMobile =
  /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent) ||
  window.matchMedia("(max-width: 768px)").matches;

export default function PdfViewer({ pdf, documentToShow }) {
  const size = useWindowSize();

  React.useEffect(() => {
    if (pdf && isMobile) {
      window.open(documentToShow, "_blank");
    }
  }, [pdf]);
  if (pdf) {
    return (
      <embed
        height={size.height - 5}
        width={size.width}
        src={documentToShow}
      ></embed>
    );
  } else {
    return <img src={documentToShow} />;
  }
}
